// add your site specific javascript here
(function ( $ ) {
	'use strict';

	$.ajaxSetup( {
		cache: true
	} );



	$(window).load(function() {
		$('body').addClass('window-loaded');
	});


	$.fn.isOnScreen = function(options) {

		var settings = $.extend({
			offsetTop: "100"
		}, options );

		if(options)
		{
			var $offsetTop = settings.offsetTop;
		}
		else
		{
			var $offsetTop = 0;
		}

		var elementTop = $(this).offset().top + $offsetTop;
		var elementBottom = elementTop + $(this).outerHeight();

		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	};

	//For crawler
	if ( !window.JS_ENABLED ) {
		$.ajax( {
			url:      window.makeUrl( { module: 'eshop', action: 'setJavascriptEnabled' } ),
			type:     'post',
			dataType: 'json'
		} );
	}

	/*
		if($('[data-zg-role="read-more-text"]').length){
			$( '[data-zg-role="read-more-text"]' ).readmore({
				moreLink: '<a href="#">' + JS_TRANSLATIONS.readMore + '</a>',
				speed: 500,
				collapsedHeight: 120,
				lessLink: '<a href="#">' + JS_TRANSLATIONS.close + '</a>'
			});
		}	

	*/

	if($('.lazy[data-src]').length){
		[].forEach.call(document.querySelectorAll('.lazy[data-src]'), function(img) {
			img.setAttribute('src', img.getAttribute('data-src'));
			img.onload = function() {
				img.removeAttribute('data-src');
			};
		});		
	}		

	if($('.lazybg[data-src]').length){
		[].forEach.call(document.querySelectorAll('.lazybg[data-src]'), function(element) {
			element.setAttribute('style', element.getAttribute('data-style'));
			element.onload = function() {
				element.removeAttribute('data-style');
			};
		});		
	}		


	var headerHeight = $("#site_header").height();
	//headerHeight = parseInt(headerHeight);
	if ( SGL_JS_MANAGER === 'home')
	{
		//$("#site_main").css({'margin-top':headerHeight+'px'});
	}


	$(window).scroll(function(){
		$('.homeVideo').each(function(){
			if ($(this).isOnScreen(-headerHeight)) {

				$(this)[0].play();
			} else {

				$(this)[0].pause();
			}
		})
	})


	// -----------------------------------------------------------------------------------------------------------------
	// Anything to be initialized on document ready goes here

	$( function () {
		//First modal registration
		$( '#registrationModalThanks' ).modal( 'show' );

		// If we have an "active" tab we start with that one selected, otherwise we select the first one
		$( '.nav-tabs' ).each( function () {
			var $activeTab = $( this ).find( '.active [data-toggle="tab"]:first' );

			if ( $activeTab.length ) {
				$activeTab.tab();
			} else {
				$( this ).find( '[data-toggle="tab"]:first' ).tab();
			}
		} );

		// Carousel Settings - Home
		$( '.carousel' ).carousel( {} );

		// SWIPE CAROUSEL
		var $carousel = $( '.carousel' );
		if ( $carousel.length ) {
			$carousel.swiperight( function () {
				$( this ).carousel( 'prev' );
			} );
			$carousel.swipeleft( function () {
				$( this ).carousel( 'next' );
			} );
		}
	} );

	$( function () {
		$( this ).find( '[data-zg-role="search-input"]').each( function(){
			//Bind the search function
			$( this ).on('input paste', function(){


				// Retrieve the input field text and reset the count to zero
				var filter = $(this).val(), count = 0;

				// Loop through the comment list
				$('[data-zg-role="search-items"]').each(function(){

					// If the list item does not contain the text phrase fade it out
					if ($(this).text().search(new RegExp(filter, "i")) < 0) {
						$(this).fadeOut();

						// Show the list item if the phrase matches and increase the count by 1
					} else {
						$(this).show();
						//if is the first visible I also show the function definition
						/*if(count == 0){
								console.log($(this).find('a'));
							}*/

						count++;
					}
				});

				// Update the count
				if(count > 0){
					$("#noResult").addClass('hide');
				}
				else{
					$("#noResult").removeClass('hide');
				}
				$("#filter-count").text(count);
				$(".count-hide").removeClass('hide');

			});
		});

	});

	//Scroll slowly to the target
	$( function () {
		$('[data-zg-scrollTo="slowly"]').click(function () {
			var target = $(this).data('zg-target'),
					href = $(this).attr("href"),
					offsetInserted = $(this).data('zg-offset'),
					offset = $(target).offset().top;

			if( offsetInserted ){
				offset -= offsetInserted;
			}
			$('html, body').animate({scrollTop: offset}, 1000);
			window.location.hash = href;
		});
	});


	// Redirecting to the "Messages" tab in the My Acoount page when the user clicks on "View my messages"
	if ( SGL_JS_MANAGER === 'account' && window.location.hash === '#tickets' ) {
		$( '#tabs-account li a[href="#tickets"]' ).tab( 'show' );
	}


	// Fading out the bouncing arrow for the Home Page slider
	$( window ).scroll( function(){
		$(".arrow").css("opacity", 1 - $(window).scrollTop() / 250);
		//250 is fade pixels
	});

	$( '[data-zg-role="btn-search"]' ).click( function(){
		$( '#searchContainer').fadeIn( '350',function(){
			$('#site_main').addClass('blurredMain');
		});
	});

	$("#closeSearch").click( function(){
		$( '#searchContainer').fadeOut('fast',function(){
			$('#site_main').removeClass('blurredMain');
		});

	});


	// ===== Scroll to Top ====
	$( window ).scroll( function() {
		if ( $( this ).scrollTop() > 200) {        // If the page is scrolled more than 200px
			$( '#return-to-top' ).fadeIn( 200 );
		} else {
			$( '#return-to-top' ).fadeOut( 200 );
		}
	});
	$( '#return-to-top' ).click(function() {
		$( 'body,html' ).animate({
			scrollTop : 0
		}, 500);
	});

	//Increasing-decreasing qty input
	$( '[data-zg-role="change-qty"]' ).click( function(e){
		e.preventDefault();
		var type = $( this ).data( 'type' );
		var $inputQtySibling = $( this ).parent().siblings( '[data-zg-role="quantity"]' );
		var maxQty = $inputQtySibling.data( 'max' );
		var floatQty = $inputQtySibling.data( 'floatQty' );
		var qty = $inputQtySibling.val();
		var step;

		if( floatQty ){
			step = 0.01;
		}
		else {
			step = 1;
		}
		qty = Number(qty);

		$( '[data-zg-role="change-qty"]' ).attr( 'disabled', false );
		if( type == "minus" ){
			//If qty is 0, we will disable the current minus icon. 
			//The next time this function will be run, all the change qty icons will be enabled again.
			if( qty == 0 ){
				$( this ).attr( 'disabled', true );
			}
			else{
				qty = qty - step;
			}
		}
		else {
			//If qty is equal to maxQty, we will disable the current plus icon. 
			//The next time this function will be run, all the change qty icons will be enabled again.
			if( qty == maxQty ){
				$( this ).attr( 'disabled', true );
			}
			else {
				qty = qty + step;
			}
		}

		$( this ).parent().siblings( '[data-zg-role="quantity"]' ).val( qty );
	});


	if(IS_MOBILE === false)
	{	
		$('#topmenu .dropdown-toggle').click(function(e) {
			if ($(document).width() > 768) {

				e.preventDefault();

				var url = $(this).attr('href');


				if (url !== '#') {

					window.location.href = url;
				}

			}
		});


		$('#topmenu li.dropdown').hover(
			function(){
				$(this).addClass('open hoverbg');
				$("#site_header").removeClass('opaque').addClass('hoverbg');

			},
			function(){
				$(this).removeClass('open hoverbg');
				$("#site_header").removeClass('hoverbg').addClass('opaque');
			});
	}

	$("#filterMobileBtn").on('click',function(){
		$("#mobile-filters-overlay").fadeIn('fast',function(){

			$("#mobile-filters").animate({
				'right':0
			});

		});
	});

	$(".closex, #mobile-filters-footer .link").on('click',function(e){
		e.preventDefault();
		$("#mobile-filters").animate({
			'right':'-300px'
		},function(){
			$("#mobile-filters-overlay").fadeOut('fast');			
		});
	});


	$('[data-zg-role="cart"]').on("show.bs.dropdown", function(event){



		$(".overlayCart").show().animate({'opacity':1},function(){
			setTimeout(function(){ 
				$('#cartDropDown').addClass('focuscart');
				$('body').addClass('lockScroll');
			}, 250);
		});

	});	

	$('[data-zg-role="cart"]').on("hide.bs.dropdown", function(event){


		$(".overlayCart").animate({'opacity':0},function(){
			setTimeout(function(){ 
				$('#cartDropDown').addClass('sfocuscart').removeClass('focuscart').removeClass('sfocuscart');
				$('body').removeClass('lockScroll');
			}, 250);
		}).hide();
	});


	if($('.catbigimg').length){	
		var productpreviewH = $('.product-preview').height();
		var covercatimg = $('.catbigimg');

		var altezzacover = (parseInt(productpreviewH)*2)+30;


		covercatimg.css({'height':+'px'});
	}	



	if(!IS_MOBILE)
	{
		/*$( function () {
			$( document ).on('zg.getProductInfo.success', function (e, products, filters, $container) {

				var roleDiv = $container.data('zg-role');


				if($container.length)
				{
					console.log('div trovato');
					var $itemBox = $container.find('#filter-container');
					var $productBox = $container.find('[data-zg-role="pagination-container"]');


					$( document ).on( 'zg.getProductInfo.productCreated', function(item, opzioni, prodotto){
						var $item = $itemBox.find('.filter');

						if($('.lazy[data-src]').length){
							[].forEach.call(document.querySelectorAll('.lazy[data-src]'), function(img) {
								img.setAttribute('src', img.getAttribute('data-src'));
								img.onload = function() {
									img.removeAttribute('data-src');
								};
							});		
						}	

					} );
				}
			});
		});*/

		$( function () {
			$( document ).on('zg.getProductInfo.success', function (e, products, filters, $container) {

				var roleDiv = $container.data('zg-role');

				console.log("ProductInfo success");

				if($container.length)
				{

					var $itemBox = $container.find('#filter-container');


					$( document ).on( 'zg.getProductInfo.productCreated', function(item, opzioni, prodotto){

						if($('.lazy[data-src]').length){
							[].forEach.call(document.querySelectorAll('.lazy[data-src]'), function(img) {
								img.setAttribute('src', img.getAttribute('data-src'));
								img.onload = function() {
									img.removeAttribute('data-src');
								};
							});		
						}			

						/*var $item = $itemBox.find('.filter');
						console.log($item);

					$item.each(function(){
						var scrollPane = $(this).find('.scroll-pane > .content-filter');
						scrollPane.jScrollPane();				
					});		
						*/

					} );
				}

			});
		});
	}



	$( document ).on('zg.product.optionSelected', function (e,option) {

		var optionID = option.optionId;
		var optionValue = option.value;
		var elementShown = 'g'+optionValue;



		if(optionID == 4)
		{
			$(".mobileSlickPhotoContainer").removeClass('show').addClass("hidden");
			$('#'+elementShown).removeClass('hidden').addClass('show').slick('refresh',{
				autoplay: false,
				dots:true,  
				fade: false,
				cssEase: 'linear',
				arrows: false
			});
		}

	});

	$('.mobileSlickPhotoContainer').slick({
		autoplay: false,
		dots:true,  
		fade: false,
		cssEase: 'linear',
		arrows: false
	});



	if(IS_MOBILE !== false)
	{
		$( document ).on('zg.getProductInfo.success', function (e, products, filters, $container) {
			if( 
				$container.length && 
				$container.hasClass('mobileSlickPhotoContainer2')
			)
			{

				//	console.log($container);
				//INIT SLICK CAROUSEL
				$container.slick({
					autoplay:true,
					pauseOnHover:true,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows:true,
					dots:false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								autoplay:true,
								pauseOnHover:false,
								arrows: true,
								dots:false,
								slidesToShow: 1,
								slidesToScroll: 1
							}
						},
						{
							breakpoint: 480,
							settings: {
								autoplay:true,
								pauseOnHover:false,
								arrows: false,
								dots:false,
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
				});

			}

		}); 
	}

	$( document ).on('zg.product.optionSelected', function (e,option) {

		if($('.lazy[data-src]').length){
			[].forEach.call(document.querySelectorAll('.lazy[data-src]'), function(img) {
				img.setAttribute('src', img.getAttribute('data-src'));
				img.onload = function() {
					img.removeAttribute('data-src');
				};
			});		
		}			

		var optionID = option.optionId;
		var optionValue = option.value;
		var elementShown = 'g'+optionValue;

		//console.log(elementShown);


		if(!IS_MOBILE)
		{
			setTimeout(function(){
				var productImgBlockHeight = $('[data-zg-role="gallery"]').height();
				var fixableBlockHeight = $('.fixable').height();

				var fixHeight = productImgBlockHeight - fixableBlockHeight;

				if(fixHeight > 0)
				{			
					$(window).bind('scroll', function() {

						if ($(window).scrollTop() > 0 && $(window).scrollTop() <= fixHeight) {
							$('.fixable').addClass('fixed').removeClass('bottom');
						}
						else {
							if ($(window).scrollTop() > fixHeight)
							{
								$('.fixable').removeClass('fixed').addClass('bottom');
							}
							else
							{
								$('.fixable').removeClass('fixed').removeClass('bottom');
							}
						}
					});						
				}
			},100);

		}

		if(IS_MOBILE !== false)
		{

			//console.log('mi trovo nel percorso mobile, prodotto definito');
			$(".mobileSlickPhotoContainer_").slick({
				autoplay: false,
				dots:true,  
				fade: false,
				cssEase: 'linear',
				arrows: true
			});

		}

		$('#btn-add-to-cart').on('click.zg.product.addToCart',function(e){
			//console.log('clicco sul btn addtocart');
			var disabled = $(this).is(":disabled");
			if(disabled)
			{
				console.log('pulsnate acquista disabilitato');
				$('#btn-add-to-cart').prop("disabled", false);
			}
		});



	});


	if(IS_MOBILE !== false)
	{

		$(".footermobile").on('click ',function(e){
			//console.log('ho cliccato sul lead');
			$(this).find('ul.nav').slideToggle();

		});

	}

	var $menu = $('nav#menu').mmenu({
		extensions 	: [ "shadow-panels", "fx-panels-slide-100", "border-none", "fullscreen"],
		setSelected	: true,
		counters	: false,
		sidebar		: {
			collapsed		: {
				use 			: '(min-width: 450px)',
				size			: 40,
				hideNavbar		: false
			},
			expanded		: {
				use 			: '(min-width: 992px)',
				size			: 35
			}
		},
		navbars		: [  {
			content		: [ 'prev', 'breadcrumbs', 'close' ]
		}, {
			position	: 'bottom',
			content		: [ 
				'<a href="https://www.facebook.com/#/" target="_blank"><i class="fa fa-facebook-square"></i></a>', 
				'<a href="https://www.instagram.com/#/" target="_blank"><i class="fa fa-instagram"></i></a>']
		}
								]
	}, {

		navbars		: {
			breadcrumbs	: {
				removeFirst	: true
			}
		}
	});


	if(IS_MOBILE !== false)
	{
		var $icon = $("#menuicon");
		var API = $menu.data( "mmenu" );

		$icon.on( "click", function() {
			API.open();
		});

		API.bind( "open:start", function() {
			setTimeout(function() {
				$icon.addClass( "hidden" );
				//$icon.html('<i class="fa fa-times"></i>');
			}, 100);
		});

		API.bind( "close:finish", function() {
			setTimeout(function() {
				$icon.removeClass( "hidden" );
				//$icon.html('<i class="fa fa-bars"></i>');
			}, 100);
		});
	}

	/*
	$( document ).on('zg.product.optionSelected', function (e,option) {

		var optionID = option.optionId;
		var optionValue = option.value;
		var elementShown = 'g'+optionValue;

		console.log(elementShown);

		if(optionID == 4)
		{
			$(".mobileSlickPhotoContainer").removeClass('show').addClass("hidden");
			$('#'+elementShown).removeClass('hidden').addClass('show').slick('refresh',{
				autoplay: false,
				dots:true,  
				fade: false,
				cssEase: 'linear',
				arrows: true
			});
		}

	});

	$('.mobileSlickPhotoContainer').slick({
		autoplay: false,
		dots:true,  
		fade: false,
		cssEase: 'linear',
		arrows: true
	});
*/


	/*document.querySelectorAll('img.svg').forEach((el) => {

      const imgID = el.getAttribute('id');
      const imgClass = el.getAttribute('class');
      const imgURL = el.getAttribute('src');

	console.log('SVG img: '+imgURL);

      fetch(imgURL)
          .then(data => data.text())
          .then(response => {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(response, 'text/html');
                let svg = xmlDoc.querySelector('svg');

                if (typeof imgID !== 'undefined') {
                    svg.setAttribute('id', imgID);
                }

                if(typeof imgClass !== 'undefined') {
                    svg.setAttribute('class', imgClass + ' replaced-svg');
                }

                svg.removeAttribute('xmlns:a');

                el.parentNode.replaceChild(svg, el);
          })
});
*/

	function get_hostname(url) {
		var m = url.match(/^https:\/\/[^/]+/);
		return m ? m[0] : null;
	}


	//Redo XML
	$(window).load(function() {
		jQuery('.svg').each(function(){
			var $img = jQuery(this);
			var imgID = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL = $img.attr('src');

			var urlCDN = get_hostname(imgURL);
			var imgPath = imgURL.replace(urlCDN, SGL_JS_WEBROOT);

			jQuery.get(imgPath, function(data) {
				// Get the SVG tag, ignore the rest

				var $svg = jQuery(data).find('svg');

				// Add replaced image's ID to the new SVG
				if(typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if(typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass+' replaced-svg');
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');

				// Check if the viewport is set, else we gonna set it if we can.
				if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
				}

				// Replace image with new SVG
				$img.replaceWith($svg);

			}, 'xml');

		});
	});


	/* [codice per aprire la gallery] del colore giusto, a partire dalla foto grande visualizzata ---- VERSIONE DESKTOP*/
	if(IS_MOBILE === false)
	{
		$(document).ready(function() {		
			$("[data-zg-role='gallery']").find(".thumbnail").click(function() { 

				var id_colore = $("#colorePrin").attr('data-color-value');


				var id_foto = $(".thumbnail.active img").attr('alt').split(' ')[1]-1;


				var options = {					
					/*history: false,
								focus: false,
								showAnimationDuration: 0,
								hideAnimationDuration: 0,*/
					fullscreenEl: false,
					history: false,
					index: id_foto						
				};

				var pswpElement = document.querySelectorAll('.pswp')[0];

				var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, window["pswpItem_" + id_colore], options);

				gallery.listen('beforeChange', function() {
					$("#captionBMphoto").html(gallery['currItem']['title']);						
					$("#boxPhotoSwipeBM_counter").html(1+gallery.getCurrentIndex()+" / "+gallery['items'].length);						
				});

				gallery.init();					
			});	
		});	
	}
	else
	{
		$(document).ready(function() {		
			$(".mobileSlickPhotoContainer").find(".product-gallery_").click(function() { 

				var id_colore = $("#colorePrin").attr('data-color-value');


				var id_foto = $(".slick-active").attr('data-id-pic');


				var options = {					
					/*history: false,
								focus: false,
								showAnimationDuration: 0,
								hideAnimationDuration: 0,*/
					fullscreenEl: false,
					history: false,
					index: id_foto						
				};

				var pswpElement = document.querySelectorAll('.pswp')[0];

				var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, window["pswpItem_" + id_colore], options);

				gallery.listen('beforeChange', function() {
					$("#captionBMphoto").html(gallery['currItem']['title']);						
					$("#boxPhotoSwipeBM_counter").html(1+gallery.getCurrentIndex()+" / "+gallery['items'].length);						
				});

				gallery.init();					
			});	
		});			
	}

	//ROBERTO

	if((IS_TABLET !== false) && (SGL_JS_MANAGER === 'home')){
		if(window.innerHeight > window.innerWidth){
			$('.vh100').css('min-height','50vh');
		} else {
			$('.vh100').css('min-height','100vh');
		}
	}


	$(window).on("orientationchange",function(){
		if((IS_TABLET !== false) && (SGL_JS_MANAGER === 'home')){
			if(window.innerHeight > window.innerWidth){
				$('.vh100').css('min-height','100vh');
			} else {
				$('.vh100').css('min-height','50vh');
			}
		}
	});		




	$('.brands-nav > .nav-item > a').click(function() {
		console.log('Altezza da escluder: '+headerHeight);
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {

			var target = $(this.hash);
			var href = $.attr(this, 'href');
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {				
				$('html,body').animate({
					scrollTop: target.offset().top - (headerHeight+60)
				}, 750, function () {

					//window.location.hash = href;

				});
				return false;
			}
		}
	});

})( jQuery );
